import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

// Geçici olarak açık bırakabilirsiniz.
// Sorun çözüldükten sonra false yapabilirsiniz.
Pusher.logToConsole = true;

const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content') || '';

const scheme = String(
    import.meta.env.VITE_REVERB_SCHEME || 'https'
).toLowerCase();

const forceTLS = scheme === 'https';

const port = Number(
    import.meta.env.VITE_REVERB_PORT || (forceTLS ? 443 : 80)
);

const host = String(
    import.meta.env.VITE_REVERB_HOST || window.location.hostname
);

const key = String(
    import.meta.env.VITE_REVERB_APP_KEY || ''
);

if (!key) {
    console.error(
        '[Home Reverb] VITE_REVERB_APP_KEY boş. npm run build yeniden alınmalıdır.'
    );
}

// Eski veya ikinci bağlantıyı kapat.
if (window.Echo) {
    try {
        window.Echo.disconnect();
    } catch (error) {
        console.warn('[Home Reverb] Eski bağlantı kapatılamadı.', error);
    }
}

window.Echo = new Echo({
    broadcaster: 'reverb',

    key,

    wsHost: host,
    wsPort: port,
    wssPort: port,

    forceTLS,

    // ÖNEMLİ:
    // forceTLS=true olduğunda Pusher bunu wss olarak kullanır.
    // Yalnızca ['wss'] kullanmayın.
    enabledTransports: ['ws'],

    authEndpoint: '/broadcasting/auth',

    csrfToken,

    auth: {
        headers: {
            'X-CSRF-TOKEN': csrfToken,
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
        },
    },
});

window.__HOME_ECHO_BUILD__ = '2026-07-17-transport-fix';

const connection = window.Echo
    ?.connector
    ?.pusher
    ?.connection;

if (connection) {
    connection.bind('state_change', ({ previous, current }) => {
        console.info(
            `[Home Reverb] ${previous} -> ${current}`
        );
    });

    connection.bind('connecting', () => {
        console.info('[Home Reverb] connecting');
    });

    connection.bind('connected', () => {
        console.info(
            '[Home Reverb] connected',
            connection.socket_id || ''
        );
    });

    connection.bind('unavailable', () => {
        console.error('[Home Reverb] unavailable');
    });

    connection.bind('failed', () => {
        console.error('[Home Reverb] failed');
    });

    connection.bind('error', error => {
        console.error(
            '[Home Reverb] connection error',
            error
        );
    });
}

function notifyEchoReady() {
    const detail = {
        echo: window.Echo,
    };

    document.dispatchEvent(
        new CustomEvent('home:echo-ready', { detail })
    );

    window.dispatchEvent(
        new CustomEvent('home:echo-ready', { detail })
    );
}

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        notifyEchoReady,
        { once: true }
    );
} else {
    notifyEchoReady();
}
